import { Observable, of, Subject } from 'rxjs';
import { mergeMap, throttleTime } from 'rxjs/operators';

/**
 * Throttle UI events or http requests.
 * Docs: https://rxjs.dev/api/operators/throttle
 */
export class Throttle<EventValue> {
    private readonly throttle$ = new Subject<() => Observable<EventValue>>();

    readonly value$ = this.throttle$.pipe(
        throttleTime(this.timeInMs),
        mergeMap((src) => src()),
    );

    constructor(readonly timeInMs = 600) {}

    next(event: () => Observable<EventValue>): void {
        this.throttle$.next(event);
    }

    nextValue(eventValue: EventValue): void {
        this.next(() => of(eventValue));
    }
}
